export default __webpack_public_path__ + "static/media/detail-console.ba5981b3.webp";